/* Mobile layout study. The existing configurator owns selection and cart state. */
export function setupMobileWorkspace(root, { placeSample }) {
  if (root.dataset.mobileWorkspaceReady) return;
  root.dataset.mobileWorkspaceReady = 'true';
  const mobile = matchMedia('(max-width: 989px)');
  const layout = root.querySelector('.fmnv-p3d__layout');
  const stage = root.querySelector('.fmnv-p3d__stage');
  const buy = root.querySelector('.fmnv-p3d__buy');
  const filter = root.querySelector('.fmnv-p3d__sffilter');
  const sample = root.querySelector('[data-p3d-add-sample]');
  if (!layout || !stage || !buy || !filter || !sample) return;
  layout.parentElement.classList.add('p3dm-frame');
  const button = (label, className) => {
    const el = document.createElement('button');
    el.type = 'button'; el.className = className; el.textContent = label;
    return el;
  };
  const enlarge = button('Ansicht vergrößern', 'p3dm-enlarge');
  enlarge.setAttribute('aria-pressed', 'false');
  stage.querySelector('.fmnv-p3d__viewer-main').append(enlarge);

  const filterHead = document.createElement('div'); filterHead.className = 'p3dm-filter-head';
  const filterLabel = document.createElement('span'); filterLabel.textContent = 'Stoff & Farbe entdecken';
  const filterToggle = button('Farbfilter', 'p3dm-filter-toggle');
  filter.id = `${root.id}-mobile-filters`;
  filterToggle.setAttribute('aria-controls', filter.id);
  filterToggle.setAttribute('aria-expanded', 'false');
  filterHead.append(filterLabel, filterToggle); filter.before(filterHead);
  const applyFilters = button('Stoffe anzeigen', 'p3dm-filter-apply');
  filter.append(applyFilters);

  const selection = document.createElement('div'); selection.className = 'p3dm-selection';
  const swatch = document.createElement('span'); swatch.className = 'p3dm-selection-swatch'; swatch.setAttribute('aria-hidden', 'true');
  const selectionName = document.createElement('span'); selectionName.className = 'p3dm-selection-name';
  selection.append(swatch, selectionName); buy.prepend(selection);
  const sampleSlot = document.createElement('div'); sampleSlot.className = 'p3dm-sample-slot'; sampleSlot.dataset.mobileSampleSlot = '';
  buy.append(sampleSlot);

  let active = false;
  function step() { return root.querySelector('[data-p3d-step].is-open')?.dataset.p3dStep || '1'; }
  function updateSelection() {
    selectionName.textContent = root.dataset.mobileSelection || 'Wähle deinen Stoff';
    swatch.style.backgroundImage = root.dataset.mobileSwatch ? `url("${root.dataset.mobileSwatch}")` : '';
  }
  function updateState() {
    const current = step();
    root.dataset.mobileStep = current;
    updateSelection();
    if (active) placeSample();
  }
  function updateViewport() {
    if (!active) return;
    const viewport = window.visualViewport;
    // Keep pinch zoom native. Browser chrome/orientation changes still resize the workspace.
    if (viewport && Math.abs(viewport.scale - 1) > .05) return;
    root.style.setProperty('--p3dm-height', `${viewport?.height || innerHeight}px`);
    // Everything above the workspace (announcement bar + header), not just the
    // header: with only --header-height the buy bar sat 36px below the screen
    // edge whenever the announcement bar was open (audit 2026-10-05).
    const offset = Math.max(0, Math.round(root.getBoundingClientRect().top + scrollY));
    root.style.setProperty('--p3dm-offset', `${offset}px`);
  }
  function setFilters(open) {
    root.classList.toggle('p3dm-filters-open', open);
    filterToggle.setAttribute('aria-expanded', String(open));
    if (!open && active) filterToggle.focus({ preventScroll: true });
  }
  function enter() {
    if (active || !mobile.matches) return;
    // This is the product page's mobile layout, not a second, modal mode.
    // The remaining product content stays in normal document flow below it.
    active = true;
    document.documentElement.classList.add('p3dm-page');
    root.classList.add('is-mobile-workspace');
    updateViewport(); placeSample(); updateSelection();
    root.dataset.mobileStep = step();
    requestAnimationFrame(() => dispatchEvent(new Event('resize')));
  }
  function exit() {
    if (!active) return;
    active = false;
    root.classList.remove('is-mobile-workspace', 'p3dm-large', 'p3dm-filters-open');
    filterToggle.setAttribute('aria-expanded', 'false');
    setEnlarged(false);
    document.documentElement.classList.remove('p3dm-page');
    placeSample();
    requestAnimationFrame(() => dispatchEvent(new Event('resize')));
  }
  function setEnlarged(large) {
    root.classList.toggle('p3dm-large', large);
    enlarge.setAttribute('aria-pressed', String(large));
    enlarge.setAttribute('aria-label', large ? 'Ansicht verkleinern' : 'Ansicht vergrößern');
    if (large) {
      enlarge.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><path d="M4 9h5V4m11 11h-5v5M9 9 3 3m12 12 6 6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    } else {
      enlarge.textContent = 'Ansicht vergrößern';
    }
  }
  enlarge.addEventListener('click', () => {
    setEnlarged(!root.classList.contains('p3dm-large'));
  });
  filterToggle.addEventListener('click', () => setFilters(!root.classList.contains('p3dm-filters-open')));
  applyFilters.addEventListener('click', () => setFilters(false));
  const updateFilterCount = () => {
    const count = filter.querySelectorAll('.is-active').length;
    filterToggle.textContent = count ? `Farbfilter (${count})` : 'Farbfilter';
  };
  new MutationObserver(updateFilterCount).observe(filter, {subtree:true,childList:true,attributes:true,attributeFilter:['class']});
  updateFilterCount();
  root.addEventListener('p3d:mobile-state', updateState);
  root.addEventListener('p3d:mobile-selection', updateSelection);
  mobile.addEventListener('change', () => { mobile.matches ? enter() : exit(); });
  window.visualViewport?.addEventListener('resize', updateViewport);
  window.visualViewport?.addEventListener('scroll', updateViewport);
  addEventListener('resize', updateViewport);
  // Closing the announcement bar moves the workspace up without a resize event.
  if ('ResizeObserver' in window) new ResizeObserver(() => updateViewport()).observe(document.body);
  updateState();
  enter();
}
